import type { ReactNode } from "react";

import { Header } from "./Header";
import { Footer } from "./Footer";
import { WhatsAppChatProvider } from "./WhatsAppChat";

export function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <WhatsAppChatProvider>
      <div className="flex min-h-screen flex-col">
        <Header />
        <main className="flex-1">{children}</main>
        <Footer />
      </div>
    </WhatsAppChatProvider>
  );
}
